import { EditablePriceList, PriceListSummary } from "../types";
import { scaffoldEdit } from "common/scaffolding/reducers/scaffoldEdit";

export enum TypeKeys {
    FETCH_BEGIN = "PRICELIST/FETCH_EDITABLE_BEGIN",
    FETCH_SUCCESS = "PRICELIST/FETCH_EDITABLE_SUCCESS",
    FETCH_FAILURE = "PRICELIST/FETCH_EDITABLE_FAILURE",

    SAVE_BEGIN = "PRICELIST/SAVE_EDITABLE_BEGIN",
    SAVE_SUCCESS = "PRICELIST/SAVE__EDITABLE_SUCCESS",
    SAVE_FAILURE = "PRICELIST/SAVE_EDITABLE_FAILURE",
}

const edit = scaffoldEdit<EditablePriceList, PriceListSummary, typeof TypeKeys>(TypeKeys);
const { createAction, reducer } = edit;

export type State = ReturnType<typeof edit.reducer>;
export { createAction, reducer };

export type SavedAction = ReturnType<typeof createAction.saved>;
